document.addEventListener('DOMContentLoaded', function() {
  let slider = document.querySelector('.brand-slider .slides');
  if (slider) {
    new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: true,
      pageDots: false
    });
  }
});